import { useEffect } from "react"
import { computeColumnOrderCorrection } from "connected-components/asset-view/helpers"

// Keeps the asset view's selected column order valid as options/mode change.
// Extracted from AssetView so the effect is testable without rendering the full component.
export function useColumnOrderCorrection({ columnOrder, options, order, setColumnOrder }) {
  useEffect(() => {
    const { nextColumnOrder } = computeColumnOrderCorrection({ columnOrder, options, order })

    if (nextColumnOrder !== undefined) {
      setColumnOrder(nextColumnOrder)
    }
  }, [columnOrder, options, order, setColumnOrder])
}
